module.exports = __webpack_public_path__ + "static/media/audbility_tint_purple.a164a829.svg";